// extracted by mini-css-extract-plugin
module.exports = {"GlobalHeader":"GlobalHeader_GlobalHeader__vWfI6","options":"GlobalHeader_options__dXujh"};